module.exports = __webpack_public_path__ + "img/cgd3.6746cfe9.jpg";